module.exports = __webpack_public_path__ + "static/media/Hochzeitseinladung-6.060b8f78.png";